<template>
  <div class="sf-charteditor-wrapper">
    <GraphNavbar v-if="!isNewLayout"></GraphNavbar>
    <div class="sf-charteditor">
      <div class="sf-charteditor-left">
        <TitleAndType></TitleAndType><GraphValuesList></GraphValuesList
        ><MaximumAndMinimumValues></MaximumAndMinimumValues>
      </div>
      <div class="sf-charteditor-right">
        <XaxisSelector></XaxisSelector>
        <div class="sf-pad-2">
          <SfPreview></SfPreview><SfDescription></SfDescription>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SfDescription from './sf-description.vue'
import GraphValuesList from './graph-values-list.vue'
import MaximumAndMinimumValues from './maximum-and-minimum-values.vue'
import GraphNavbar from './graph-navbar'
import { isUsingNewLayout } from '@app/adapters/silverfin'
import SfPreview from './sf-preview.vue'
import TitleAndType from './title-and-type.vue'
import XaxisSelector from './xaxis-selector.vue'

const ReportGraphEditor = {
  components: {
    SfDescription,
    GraphValuesList,
    MaximumAndMinimumValues,
    GraphNavbar,
    SfPreview,
    TitleAndType,
    XaxisSelector,
  },
  computed: {
    isNewLayout() {
      return isUsingNewLayout()
    },
  },
}

export default ReportGraphEditor
</script>
